import { render, staticRenderFns } from "./ElectrodeFixTwo.vue?vue&type=template&id=1565ee06&scoped=true"
import script from "./ElectrodeFixTwo.vue?vue&type=script&lang=js"
export * from "./ElectrodeFixTwo.vue?vue&type=script&lang=js"
import style0 from "./ElectrodeFixTwo.vue?vue&type=style&index=0&id=1565ee06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565ee06",
  null
  
)

export default component.exports